import React from "react";
import { Container } from "@mui/material";

const PolicyPage = () => {
  return (
    <Container>
      <h2>Privacy Policy</h2>
      <p>
        We are committed to protecting your privacy. Our Privacy Policy outlines
        how we collect, use, and protect your personal information.
      </p>

      <h2>Know Your Customer (KYC) Policy</h2>
      <p>
        To use our platform, users must complete the KYC process. This helps us
        verify your identity and comply with legal requirements.
      </p>

      <h2>Anti-Money Laundering (AML) Policy</h2>
      <p>
        We have strict AML policies in place to prevent money laundering and
        illegal activities on our platform.
      </p>

      <h2>Security Policy</h2>
      <p>
        We take security seriously and have implemented measures to protect your
        assets and personal information.
      </p>

      <h2>Risk Disclosure</h2>
      <p>
        Cryptocurrency trading involves risks. Please review our Risk Disclosure
        statement to understand the risks associated with trading
        cryptocurrencies.
      </p>

      <h2>Fee Schedule</h2>
      <p>
        Our fee schedule outlines the charges for using our platform. Please
        review it before making transactions.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions or concerns about our policies or services, please
        contact us at support@example.com.
      </p>

      <h2>Changes to Policies</h2>
      <p>
        We reserve the right to update and modify our policies. Please check
        this page regularly for any changes.
      </p>

      {/* Add more sections using Typography components as needed */}
    </Container>
  );
};

export default PolicyPage;
